import React from "react";
import { useSelector } from "react-redux";


// Date Formate Change To Send The server
function dateFormateSend(datestring) {
    const date_send = new Date(datestring);
    const day = date_send.getDate();
    const month = date_send.getMonth() + 1;
    const year = date_send.getFullYear();
    return `${year}-${month < 10 ? '0' + month : month}-${day < 10 ? '0' + day : day}`;
}
// Date Formate Change To Show The UserInterface
function dateFormateShow(datestring) {
    const date_show = new Date(datestring);
    const day = date_show.getDate();
    const month = date_show.toLocaleString('default', { month: 'short' });
    const year = date_show.getFullYear();
    const result = `${day < 10 ? '0' + day : day}-${month < 10 ? '0' + month : month}-${year}`
    return result === 'NaN-Invalid Date-NaN' ? null : result;
}
// Get Day Accourding to Date
function dateDayShow(date_formated_show) {
    const date_show = new Date(date_formated_show);
    const options = { weekday: 'long' };
    return date_show.toLocaleDateString('en-US', options);
}

function getDateInFormate(date) {
    const monthNames = {
        J: 1, Ja: 1, Jan: 1, Janu: 1, Janua: 1, Januar: 1, January: 1,
        F: 2, Fe: 2, Feb: 2, Febr: 2, Febru: 2, Februa: 2, Februar: 2, February: 2,
        M: 3, Ma: 3, Mar: 3, Marc: 3, March: 3,
        A: 4, Ap: 4, Apr: 4, Apri: 4, April: 4,
        May: 5,
        Ju: 6, Jun: 6, June: 6, Jul: 7, July: 7,
        Au: 8, Aug: 8, Augu: 8, Augus: 8, August: 8,
        S: 9, Se: 9, Sep: 9, Sept: 9, Septe: 9, Septem: 9, Septemb: 9, Septembe: 9, September: 9,
        O: 10, Oc: 10, Oct: 10, Octo: 10, Octob: 10, Octobe: 10, October: 10,
        N: 11, No: 11, Nov: 11, Nove: 11, Novem: 11, Novemb: 11, Novembe: 11, November: 11,
        D: 12, De: 12, Dec: 12, Dece: 12, Decem: 12, Decemb: 12, Decembe: 12, December: 12
    };

    const match = date?.match(/^(\d{1,2})(?:[\s.\-\/,]*(J[a-z]*|F[a-z]*|M[a-z]*|A[a-z]*|S[a-z]*|O[a-z]*|N[a-z]*|D[a-z]*|\d{1,2})(?:[\s.\-\/,]*(\d{2,4}))?)?$/i);

    if (!match) return false;

    let [, day, monthTextOrNumber, yearFrom] = match;
    let day_ = parseInt(day, 10);
    let month_;
    let year_;

    if (monthTextOrNumber && isNaN(monthTextOrNumber)) {
        const normalizedMonth = monthTextOrNumber.charAt(0).toUpperCase() + monthTextOrNumber.slice(1).toLowerCase();
        month_ = monthNames[normalizedMonth] || null;
    } else {
        month_ = parseInt(monthTextOrNumber, 10);
    }

    const currentDate = new Date();
    const currentMonth = currentDate.getMonth() + 1;
    const currentYear = currentDate.getFullYear();

    if (yearFrom) {
        year_ = parseInt(yearFrom, 10);
        if (year_ < 100) {
            year_ += 2000;
        } else if (year_ < 1000 || year_ > 9999) {
            return false;
        }
    } else {
        if (month_ < 4) {
            year_ = currentMonth >= 4 ? currentYear + 1 : currentYear;
        } else {
            year_ = currentMonth >= 4 ? currentYear : currentYear - 1;
        }
    }

    if (!month_ || month_ < 1 || month_ > 12) return false;

    const daysInMonth = new Date(year_, month_, 0).getDate();
    if (day_ < 1 || day_ > daysInMonth) return false;

    return formatToStandardDate(day_, month_, year_);
}

function formatToStandardDate(day, month, year) {
    const monthNamesShort = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const monthName = monthNamesShort[month - 1];
    if (day < 10) {
        day = `0${day}`
    }

    return `${day}-${monthName}-${year}`;
}



const datePayment_func = (date_get, voucher_date, date_payment_input_ref, company_session) => {
    let date_payment_to;
    const match = date_get?.match(/^(\d+)[.\-\/](\d+)[.-\/]?(\d*)$/);
    if (match) {
        const [, day, month, year_from] = match;
        const year = new Date(company_session?.start_financial_year).getFullYear();
        const financialYearStart = year;
        const financialYearEnd = new Date(company_session?.end_financial_year).getFullYear();
        if (year_from !== '') {
            const parsedMonth = parseInt(month, 10);
            if (parsedMonth >= 1 && parsedMonth <= 12) {
                let parsedYear;
                if (year_from.length === 2) {
                    const currentYear = new Date().getFullYear();
                    const currentCentury = Math.floor(currentYear / 100) * 100;
                    parsedYear = parseInt(year_from, 10) + currentCentury;
                    const daysInMonth = new Date(parsedYear, parsedMonth, 0).getDate(); // Get the number of days in the month
                    const parsedDay = parseInt(day, 10);
                    if (parsedDay >= 1 && parsedDay <= daysInMonth) {
                        const monthNames = [
                            'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                            'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
                        ];
                        const monthAbbreviation = monthNames[parseInt(month, 10) - 1];
                        date_payment_to = `${day || '01'}-${monthAbbreviation}-${parsedYear}`;
                        const new_date_check = new Date(date_payment_to)
                        const current_date_to_validate = new Date(voucher_date);
                        if (current_date_to_validate < new_date_check) {
                            date_payment_input_ref.current.focus();
                        } else {
                            return date_payment_to = `${day || '01'}-${monthAbbreviation}-${parsedYear}`;
                        }
                    } else {
                        alert('Invalid Day')
                    }
                } else if (year_from.length === 4) {
                    parsedYear = parseInt(year_from, 10);
                    const daysInMonth = new Date(parsedYear, parsedMonth, 0).getDate(); // Get the number of days in the month
                    const parsedDay = parseInt(day, 10);
                    if (parsedDay >= 1 && parsedDay <= daysInMonth) {
                        const monthNames = [
                            'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                            'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
                        ];
                        const monthAbbreviation = monthNames[parseInt(month, 10) - 1];
                        date_payment_to = `${day || '01'}-${monthAbbreviation}-${parsedYear}`;
                        const new_date_check = new Date(date_payment_to)
                        const current_date_to_validate = new Date(voucher_date);
                        if (current_date_to_validate < new_date_check) {
                            date_payment_input_ref.current.focus();
                        } else {
                            return date_payment_to = `${day || '01'}-${monthAbbreviation}-${parsedYear}`;
                        }
                    } else {
                        alert('Invalid Day')
                    }
                }
            } else {
                alert('Invalid Month')
            }
        } else {
            const parsedMonth = parseInt(month, 10);
            if (parsedMonth >= 1 && parsedMonth <= 12) {
                const startYear = month <= 3 ? financialYearEnd : financialYearStart;
                const daysInMonth = new Date(startYear, parsedMonth, 0).getDate(); // Get the number of days in the month
                const parsedDay = parseInt(day, 10);
                if (parsedDay >= 1 && parsedDay <= daysInMonth) {
                    const monthNames = [
                        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                        'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
                    ];
                    const monthAbbreviation = monthNames[parseInt(month, 10) - 1];
                    date_payment_to = `${day || '01'}-${monthAbbreviation}-${startYear}`;
                    const new_date_check = new Date(date_payment_to)
                    const current_date_to_validate = new Date(voucher_date);
                    if (current_date_to_validate < new_date_check) {
                        date_payment_input_ref.current.focus();
                    } else {
                        return date_payment_to = `${day || '01'}-${monthAbbreviation}-${startYear}`;
                    }
                } else {
                    alert('Invalid Day')
                }
            } else {
                alert('Invalid Month')
            }
        }
    } else {
        alert("Invalid date")
    }
}


function getVoucherDate(value, company_session, defaultDateString = null) {
    if (!value) {
        return null;
    }

    const cleanValue = String(value).trim();
    const cleanValueLower = cleanValue.toLowerCase();
    if (cleanValueLower === 'today' || cleanValueLower === 't') {
        const today = new Date();
        const parsedDay = today.getDate();
        const parsedMonth = today.getMonth() + 1;
        const parsedYear = today.getFullYear();
        
        const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        const formattedDateString = `${parsedDay < 10 ? '0' + parsedDay : parsedDay}-${monthNames[parsedMonth - 1]}-${parsedYear}`;
        const day_show = today.toLocaleString('en-US', { weekday: 'long' });

        return { formattedDateString, day_show };
    }

    const currentDate = new Date();
    const systemMonth = currentDate.getMonth() + 1;
    const systemYear = currentDate.getFullYear();

    // Month name mappings (including partial names)
    const monthMappings = {
        J: 1, Ja: 1, Jan: 1, Janu: 1, Janua: 1, Januar: 1, January: 1,
        F: 2, Fe: 2, Feb: 2, Febr: 2, Febru: 2, Februa: 2, Februar: 2, February: 2,
        M: 3, Ma: 3, Mar: 3, Marc: 3, March: 3,
        A: 4, Ap: 4, Apr: 4, Apri: 4, April: 4,
        May: 5,
        Ju: 6, Jun: 6, June: 6,
        Jul: 7, July: 7,
        Au: 8, Aug: 8, Augu: 8, Augus: 8, August: 8,
        S: 9, Se: 9, Sep: 9, Sept: 9, Septe: 9, Septem: 9, Septemb: 9, Septembe: 9, September: 9,
        O: 10, Oc: 10, Oct: 10, Octo: 10, Octob: 10, Octobe: 10, October: 10,
        N: 11, No: 11, Nov: 11, Nove: 11, Novem: 11, Novemb: 11, Novembe: 11, November: 11,
        D: 12, De: 12, Dec: 12, Dece: 12, Decem: 12, Decemb: 12, Decembe: 12, December: 12
    };

    // Parse default date context if available
    let defaultMonth, defaultYear;
    if (defaultDateString) {
        const parts = String(defaultDateString).split(/[.\-\/]/);
        if (parts.length === 3) {
            const mon = parts[1];
            if (isNaN(mon)) {
                const monNorm = mon.charAt(0).toUpperCase() + mon.slice(1).toLowerCase();
                defaultMonth = monthMappings[monNorm];
            } else {
                defaultMonth = parseInt(mon, 10);
            }
            defaultYear = parseInt(parts[2], 10);
        }
    }

    // Support continuous digits (no-separator) format, e.g. 1504, 150425, 15042025, 104
    let activeValue = cleanValue;
    if (/^\d{3,8}$/.test(cleanValue)) {
        let day, monthPart, yearStr;
        const len = cleanValue.length;
        if (len === 3) {
            const lastTwo = parseInt(cleanValue.slice(1), 10);
            if (lastTwo >= 10 && lastTwo <= 12) {
                day = cleanValue.slice(0, 1);
                monthPart = cleanValue.slice(1);
            } else {
                day = cleanValue.slice(0, 2);
                monthPart = cleanValue.slice(2);
            }
        } else if (len === 4) {
            day = cleanValue.slice(0, 2);
            monthPart = cleanValue.slice(2);
        } else if (len === 6) {
            day = cleanValue.slice(0, 2);
            monthPart = cleanValue.slice(2, 4);
            yearStr = cleanValue.slice(4);
        } else if (len === 8) {
            day = cleanValue.slice(0, 2);
            monthPart = cleanValue.slice(2, 4);
            yearStr = cleanValue.slice(4);
        }

        if (day && monthPart) {
            activeValue = yearStr ? `${day}-${monthPart}-${yearStr}` : `${day}-${monthPart}`;
        }
    }

    // Match patterns: Group 1: Day, Group 2: Month, Group 3: Year
    const dateMatch = activeValue.match(/^(\d{1,2})(?:[\s.\-\/,]*(J[a-z]*|F[a-z]*|M[a-z]*|A[a-z]*|S[a-z]*|O[a-z]*|N[a-z]*|D[a-z]*|\d{1,2})(?:[\s.\-\/,]*(\d{2,4}))?)?$/i);

    if (dateMatch) {
        const [, day, monthPart, yearStr] = dateMatch;
        const parsedDay = parseInt(day, 10);

        // Parse month with fallback to context or current month
        let parsedMonth;
        if (monthPart) {
            if (isNaN(monthPart)) {
                const normalizedMonth = monthPart.charAt(0).toUpperCase() + monthPart.slice(1).toLowerCase();
                parsedMonth = monthMappings[normalizedMonth];
            } else {
                parsedMonth = parseInt(monthPart, 10);
            }
        } else {
            parsedMonth = defaultMonth || systemMonth;
        }

        if (!parsedMonth || parsedMonth < 1 || parsedMonth > 12) {
            return null;
        }

        let parsedYear;
        const financialYearStart = company_session?.start_financial_year ? new Date(company_session.start_financial_year).getFullYear() : systemYear;
        const financialYearEnd = company_session?.end_financial_year ? new Date(company_session.end_financial_year).getFullYear() : systemYear + 1;

        if (!yearStr) {
            const baseYear = defaultYear || (parsedMonth <= 3 ? financialYearEnd : financialYearStart);
            parsedYear = baseYear;
            if (defaultYear && defaultMonth && parsedMonth < defaultMonth) {
                parsedYear = defaultYear + 1;
            }
            if (!parsedYear) parsedYear = systemYear;

            // If the shifted year falls out of range, but the unshifted base year is within range, fallback to baseYear
            if (company_session?.start_financial_year && company_session?.end_financial_year) {
                const checkDateWithParsed = new Date(parsedYear, parsedMonth - 1, parsedDay);
                const checkDateWithBase = new Date(baseYear, parsedMonth - 1, parsedDay);
                const startDateObj = new Date(company_session.start_financial_year);
                const endDateObj = new Date(company_session.end_financial_year);

                const start = new Date(startDateObj.getFullYear(), startDateObj.getMonth(), startDateObj.getDate());
                const end = new Date(endDateObj.getFullYear(), endDateObj.getMonth(), endDateObj.getDate());

                checkDateWithParsed.setHours(0, 0, 0, 0);
                checkDateWithBase.setHours(0, 0, 0, 0);
                start.setHours(0, 0, 0, 0);
                end.setHours(0, 0, 0, 0);

                if ((checkDateWithParsed < start || checkDateWithParsed > end) && (checkDateWithBase >= start && checkDateWithBase <= end)) {
                    parsedYear = baseYear;
                }
            }
        } else {
            parsedYear = parseInt(yearStr, 10);
            if (yearStr.length === 2) {
                const currentCentury = Math.floor(systemYear / 100) * 100;
                parsedYear = parsedYear + currentCentury;
            }
        }

        // Validate final day against month/year
        const daysInMonth = new Date(parsedYear, parsedMonth, 0).getDate();
        if (parsedDay < 1 || parsedDay > daysInMonth) {
            return null;
        }

        // Verify against financial year range with normalized midnight comparison
        if (company_session?.start_financial_year && company_session?.end_financial_year) {
            const inputDate = new Date(parsedYear, parsedMonth - 1, parsedDay);
            const startDateObj = new Date(company_session.start_financial_year);
            const endDateObj = new Date(company_session.end_financial_year);

            const start = new Date(startDateObj.getFullYear(), startDateObj.getMonth(), startDateObj.getDate());
            const end = new Date(endDateObj.getFullYear(), endDateObj.getMonth(), endDateObj.getDate());

            inputDate.setHours(0, 0, 0, 0);
            start.setHours(0, 0, 0, 0);
            end.setHours(0, 0, 0, 0);

            if (inputDate < start || inputDate > end) {
                return null;
            }
        }

        const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        const formattedDateString = `${parsedDay < 10 ? '0' + parsedDay : parsedDay}-${monthNames[parsedMonth - 1]}-${parsedYear}`;
        const dateObj = new Date(parsedYear, parsedMonth - 1, parsedDay);
        const day_show = dateObj.toLocaleString('en-US', { weekday: 'long' });

        return { formattedDateString, day_show };
    }

    return null;
}

function getValidPeriodDate(value, company_session, defaultDateString = null) {
    if (!value) {
        return null;
    }

    const cleanValue = String(value).trim();
    const cleanValueLower = cleanValue.toLowerCase();
    if (cleanValueLower === 'today' || cleanValueLower === 't') {
        const today = new Date();
        const parsedDay = today.getDate();
        const parsedMonth = today.getMonth() + 1;
        const parsedYear = today.getFullYear();
        
        const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        const formattedDateString = `${parsedDay < 10 ? '0' + parsedDay : parsedDay}-${monthNames[parsedMonth - 1]}-${parsedYear}`;
        const day_show = today.toLocaleString('en-US', { weekday: 'long' });

        return { formattedDateString, day_show };
    }

    const currentDate = new Date();
    const systemMonth = currentDate.getMonth() + 1;
    const systemYear = currentDate.getFullYear();

    // Month name mappings (including partial names)
    const monthMappings = {
        J: 1, Ja: 1, Jan: 1, Janu: 1, Janua: 1, Januar: 1, January: 1,
        F: 2, Fe: 2, Feb: 2, Febr: 2, Febru: 2, Februa: 2, Februar: 2, February: 2,
        M: 3, Ma: 3, Mar: 3, Marc: 3, March: 3,
        A: 4, Ap: 4, Apr: 4, Apri: 4, April: 4,
        May: 5,
        Ju: 6, Jun: 6, June: 6,
        Jul: 7, July: 7,
        Au: 8, Aug: 8, Augu: 8, Augus: 8, August: 8,
        S: 9, Se: 9, Sep: 9, Sept: 9, Septe: 9, Septem: 9, Septemb: 9, Septembe: 9, September: 9,
        O: 10, Oc: 10, Oct: 10, Octo: 10, Octob: 10, Octobe: 10, October: 10,
        N: 11, No: 11, Nov: 11, Nove: 11, Novem: 11, Novemb: 11, Novembe: 11, November: 11,
        D: 12, De: 12, Dec: 12, Dece: 12, Decem: 12, Decemb: 12, Decembe: 12, December: 12
    };

    // Parse default date context if available
    let defaultMonth, defaultYear;
    if (defaultDateString) {
        const parts = String(defaultDateString).split(/[.\-\/]/);
        if (parts.length === 3) {
            const mon = parts[1];
            if (isNaN(mon)) {
                const monNorm = mon.charAt(0).toUpperCase() + mon.slice(1).toLowerCase();
                defaultMonth = monthMappings[monNorm];
            } else {
                defaultMonth = parseInt(mon, 10);
            }
            defaultYear = parseInt(parts[2], 10);
        }
    }

    // Match patterns: Group 1: Day, Group 2: Month, Group 3: Year
    const dateMatch = cleanValue.match(/^(\d{1,2})(?:[\s.\-\/,]*(J[a-z]*|F[a-z]*|M[a-z]*|A[a-z]*|S[a-z]*|O[a-z]*|N[a-z]*|D[a-z]*|\d{1,2})(?:[\s.\-\/,]*(\d{2,4}))?)?$/i);

    if (dateMatch) {
        const [, day, monthPart, yearStr] = dateMatch;
        const parsedDay = parseInt(day, 10);

        // Parse month with fallback to context or current month
        let parsedMonth;
        if (monthPart) {
            if (isNaN(monthPart)) {
                const normalizedMonth = monthPart.charAt(0).toUpperCase() + monthPart.slice(1).toLowerCase();
                parsedMonth = monthMappings[normalizedMonth];
            } else {
                parsedMonth = parseInt(monthPart, 10);
            }
        } else {
            parsedMonth = defaultMonth || systemMonth;
        }

        if (!parsedMonth || parsedMonth < 1 || parsedMonth > 12) {
            return null;
        }

        let parsedYear;
        const financialYearStart = company_session?.start_financial_year ? new Date(company_session.start_financial_year).getFullYear() : systemYear;
        const financialYearEnd = company_session?.end_financial_year ? new Date(company_session.end_financial_year).getFullYear() : systemYear + 1;

        if (!yearStr) {
            parsedYear = defaultYear || (parsedMonth <= 3 ? financialYearEnd : financialYearStart);
            if (defaultYear && defaultMonth && parsedMonth < defaultMonth) {
                parsedYear = defaultYear + 1;
            }
            if (!parsedYear) parsedYear = systemYear;
        } else {
            parsedYear = parseInt(yearStr, 10);
            if (yearStr.length === 2) {
                const currentCentury = Math.floor(systemYear / 100) * 100;
                parsedYear = parsedYear + currentCentury;
            }
        }

        // Validate final day against month/year
        const daysInMonth = new Date(parsedYear, parsedMonth, 0).getDate();
        if (parsedDay < 1 || parsedDay > daysInMonth) {
            return null;
        }

        const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        const formattedDateString = `${parsedDay < 10 ? '0' + parsedDay : parsedDay}-${monthNames[parsedMonth - 1]}-${parsedYear}`;
        const dateObj = new Date(parsedYear, parsedMonth - 1, parsedDay);
        const day_show = dateObj.toLocaleString('en-US', { weekday: 'long' });

        return { formattedDateString, day_show };
    }

    return null;
}

function getInvalidFromDate(value, company_session) {
    if (!value) {
        return null;
    }

    const cleanValue = String(value).trim();
    const cleanValueLower = cleanValue.toLowerCase();
    if (cleanValueLower === 'today' || cleanValueLower === 't') {
        const today = new Date();
        const day = today.getDate();
        const month = today.getMonth() + 1;
        const year = today.getFullYear();
        
        const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        const formattedDateString = `${day < 10 ? '0' + day : day}-${monthNames[month - 1]}-${year}`;
        const numericDate = `${day < 10 ? '0' + day : day}-${month < 10 ? '0' + month : month}-${year}`;
        const day_show = today.toLocaleString('en-US', { weekday: 'long' });

        return { formattedDateString, day_show, numericDate };
    }

    let parsedDate;

    // Month name mappings (including partial names)
    const monthMappings = {
        J: 1, Ja: 1, Jan: 1, Janu: 1, Janua: 1, Januar: 1, January: 1,
        F: 2, Fe: 2, Feb: 2, Febr: 2, Febru: 2, Februa: 2, Februar: 2, February: 2,
        M: 3, Ma: 3, Mar: 3, Marc: 3, March: 3,
        A: 4, Ap: 4, Apr: 4, Apri: 4, April: 4,
        May: 5,
        Ju: 6, Jun: 6, June: 6,
        Jul: 7, July: 7,
        Au: 8, Aug: 8, Augu: 8, Augus: 8, August: 8,
        S: 9, Se: 9, Sep: 9, Sept: 9, Septe: 9, Septem: 9, Septemb: 9, Septembe: 9, September: 9,
        O: 10, Oc: 10, Oct: 10, Octo: 10, Octob: 10, Octobe: 10, October: 10,
        N: 11, No: 11, Nov: 11, Nove: 11, Novem: 11, Novemb: 11, Novembe: 11, November: 11,
        D: 12, De: 12, Dec: 12, Dece: 12, Decem: 12, Decemb: 12, Decembe: 12, December: 12
    };

    // Match patterns for both numeric and text month formats
    const dateMatch = cleanValue.match(/^(\d{1,2})(?:[\s.\-\/,]*(J[a-z]*|F[a-z]*|M[a-z]*|A[a-z]*|S[a-z]*|O[a-z]*|N[a-z]*|D[a-z]*|\d{1,2})(?:[\s.\-\/,]*(\d{2,4}))?)?$/i);

    if (dateMatch) {
        const [, day, monthPart, yearStr] = dateMatch;
        const parsedDay = parseInt(day, 10);

        // Parse month (either numeric or text)
        let parsedMonth;
        if (monthPart) {
            if (isNaN(monthPart)) {
                // Text month
                const normalizedMonth = monthPart.charAt(0).toUpperCase() + monthPart.slice(1).toLowerCase();
                parsedMonth = monthMappings[normalizedMonth];
            } else {
                // Numeric month
                parsedMonth = parseInt(monthPart, 10);
            }
        }

        // Basic month validation
        if (!parsedMonth || parsedMonth < 1 || parsedMonth > 12) {
            //alert('Invalid Month');
            return null;
        }

        let parsedYear;
        const financialYearStart = new Date(company_session?.start_financial_year).getFullYear();
        const financialYearEnd = new Date(company_session?.end_financial_year).getFullYear();

        // If year is not provided, determine based on financial year
        if (!yearStr) {
            parsedYear = parsedMonth <= 3 ? financialYearEnd : financialYearStart;
        } else {
            // Handle provided year
            parsedYear = parseInt(yearStr, 10);
            if (yearStr.length === 2) {
                const currentYear = new Date().getFullYear();
                const currentCentury = Math.floor(currentYear / 100) * 100;
                parsedYear = parsedYear + currentCentury;
            }
        }
        // Validate day
        const daysInMonth = new Date(parsedYear, parsedMonth, 0).getDate();
        if (parsedDay < 1 || parsedDay > daysInMonth) {
            return null;
        }

        parsedDate = {
            day: parsedDay,
            month: parsedMonth,
            year: parsedYear
        };
    }

    if (!parsedDate) {
        return null;
    }

    // Format the output
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
        'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const { day, month, year } = parsedDate;
    const formattedDateString = `${day < 10 ? '0' + day : day}-${monthNames[month - 1]}-${year}`;
    const numericDate = `${day < 10 ? '0' + day : day}-${month < 10 ? '0' + month : month}-${year}`;

    const dateObj = new Date(year, month - 1, day);
    const day_show = dateObj.toLocaleString('en-US', { weekday: 'long' });

    return { formattedDateString, day_show, numericDate };
}

function getCurrentFinancialPeriod() {
    const today = new Date();
    const currentYear = today.getFullYear();
    const currentMonth = today.getMonth() + 1; // 1-indexed (Jan=1, Apr=4)

    let startYear, endYear;
    if (currentMonth >= 4) {
        // From April onwards, the financial year starts in the current calendar year
        startYear = currentYear;
        endYear = currentYear + 1;
    } else {
        // Before April, the financial year started in the previous calendar year
        startYear = currentYear - 1;
        endYear = currentYear;
    }
    return `${startYear}-${endYear}`;
}


function addDecimalTwoPoint(value) {
    parseFloat(value).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
}
function currencyFormate(value) {
    // Handle null, undefined, empty string
    if (value == null || value === '') {
        return '0.00';
    }

    // Remove commas if it's a string, then convert to number
    let numValue;
    if (typeof value === 'string') {
        // Remove commas first
        const cleanedValue = value.replace(/,/g, '');
        numValue = parseFloat(cleanedValue);
    } else {
        numValue = parseFloat(value);
    }

    // Check if valid number
    if (isNaN(numValue) || numValue === 0) {
        return '0.00';
    }

    // Format the number with commas
    const result = numValue.toFixed(2).replace(/(\d+?)(?=(\d\d)+(\d)(?!\d))(\.\d+)?/g, "$1,");
    return result;
}
function currencyInputFormate(value) {
    if (value === '' || value === 0 || value === '0.00' || isNaN(value)) {
        return null;
    }
    // Remove non-numeric except dot
    const input = value.replace(/[^0-9.]/g, "");

    // Allow only one dot
    const parts = input.split(".");
    if (parts.length > 2) return;

    // Limit decimals to 2
    if (parts[1]?.length > 2) return;

    // add decimals
    if (parts.length < 2) parts[1] = '00';

    // Format number
    const formatted = parts[0]
        ? Number(parts[0]).toLocaleString("en-IN")
        : "";

    return parts.length === 2 ? `${formatted}.${parts[1]}` : formatted;

}
function removeCurrencyComma(value) {
    if (value == null) return value;
    return value.toString().replace(/,/g, '');
}

function parseNumeric(val) {
    if (val === null || val === undefined) return 0;
    if (typeof val === 'number') return val;
    const parsed = parseFloat(val);
    if (!isNaN(parsed)) return parsed;
    const match = String(val).match(/[-+]?[0-9]*\.?[0-9]+/);
    return match ? parseFloat(match[0]) : 0;
}

const formatInputToCapitalization = (input) => {
    if (!input) return "";
    const words = input.split(/\s+/);
    const formattedWords = words.map((word) => {
        if (!word) return "";
        const firstChar = word.charAt(0).toUpperCase();
        const remainingChars = word.slice(1);
        return firstChar + remainingChars;
    });
    return formattedWords.join(" ");
}

const countriesList = [
    { code: 'AF', name: 'Afghanistan' },
    { code: 'AL', name: 'Albania' },
    { code: 'DZ', name: 'Algeria' },
    { code: 'AS', name: 'American Samoa' },
    { code: 'AD', name: 'Andorra' },
    { code: 'AO', name: 'Angola' },
    { code: 'AI', name: 'Anguilla' },
    { code: 'AQ', name: 'Antarctica' },
    { code: 'AG', name: 'Antigua and Barbuda' },
    { code: 'AR', name: 'Argentina' },
    { code: 'AM', name: 'Armenia' },
    { code: 'AW', name: 'Aruba' },
    { code: 'AU', name: 'Australia' },
    { code: 'AT', name: 'Austria' },
    { code: 'AZ', name: 'Azerbaijan' },
    { code: 'BS', name: 'Bahamas' },
    { code: 'BH', name: 'Bahrain' },
    { code: 'BD', name: 'Bangladesh' },
    { code: 'BB', name: 'Barbados' },
    { code: 'BY', name: 'Belarus' },
    { code: 'BE', name: 'Belgium' },
    { code: 'BZ', name: 'Belize' },
    { code: 'BJ', name: 'Benin' },
    { code: 'BM', name: 'Bermuda' },
    { code: 'BT', name: 'Bhutan' },
    { code: 'BO', name: 'Bolivia' },
    { code: 'BA', name: 'Bosnia and Herzegovina' },
    { code: 'BW', name: 'Botswana' },
    { code: 'BV', name: 'Bouvet Island' },
    { code: 'BR', name: 'Brazil' },
    { code: 'IO', name: 'British Indian Ocean Territory' },
    { code: 'BN', name: 'Brunei Darussalam' },
    { code: 'BG', name: 'Bulgaria' },
    { code: 'BF', name: 'Burkina Faso' },
    { code: 'BI', name: 'Burundi' },
    { code: 'KH', name: 'Cambodia' },
    { code: 'CM', name: 'Cameroon' },
    { code: 'CA', name: 'Canada' },
    { code: 'CV', name: 'Cape Verde' },
    { code: 'KY', name: 'Cayman Islands' },
    { code: 'CF', name: 'Central African Republic' },
    { code: 'TD', name: 'Chad' },
    { code: 'CL', name: 'Chile' },
    { code: 'CN', name: 'China' },
    { code: 'CX', name: 'Christmas Island' },
    { code: 'CC', name: 'Cocos (Keeling) Islands' },
    { code: 'CO', name: 'Colombia' },
    { code: 'KM', name: 'Comoros' },
    { code: 'CG', name: 'Congo' },
    { code: 'CD', name: 'Congo, The Democratic Republic of the' },
    { code: 'CK', name: 'Cook Islands' },
    { code: 'CR', name: 'Costa Rica' },
    { code: 'CI', name: "Cote D'Ivoire" },
    { code: 'HR', name: 'Croatia' },
    { code: 'CU', name: 'Cuba' },
    { code: 'CY', name: 'Cyprus' },
    { code: 'CZ', name: 'Czech Republic' },
    { code: 'DK', name: 'Denmark' },
    { code: 'DJ', name: 'Djibouti' },
    { code: 'DM', name: 'Dominica' },
    { code: 'DO', name: 'Dominican Republic' },
    { code: 'EC', name: 'Ecuador' },
    { code: 'EG', name: 'Egypt' },
    { code: 'SV', name: 'El Salvador' },
    { code: 'GQ', name: 'Equatorial Guinea' },
    { code: 'ER', name: 'Eritrea' },
    { code: 'EE', name: 'Estonia' },
    { code: 'ET', name: 'Ethiopia' },
    { code: 'FK', name: 'Falkland Islands (Malvinas)' },
    { code: 'FO', name: 'Faroe Islands' },
    { code: 'FJ', name: 'Fiji' },
    { code: 'FI', name: 'Finland' },
    { code: 'FR', name: 'France' },
    { code: 'GF', name: 'French Guiana' },
    { code: 'PF', name: 'French Polynesia' },
    { code: 'TF', name: 'French Southern Territories' },
    { code: 'GA', name: 'Gabon' },
    { code: 'GM', name: 'Gambia' },
    { code: 'GE', name: 'Georgia' },
    { code: 'DE', name: 'Germany' },
    { code: 'GH', name: 'Ghana' },
    { code: 'GI', name: 'Gibraltar' },
    { code: 'GR', name: 'Greece' },
    { code: 'GL', name: 'Greenland' },
    { code: 'GD', name: 'Grenada' },
    { code: 'GP', name: 'Guadeloupe' },
    { code: 'GU', name: 'Guam' },
    { code: 'GT', name: 'Guatemala' },
    { code: 'GN', name: 'Guinea' },
    { code: 'GW', name: 'Guinea-Bissau' },
    { code: 'GY', name: 'Guyana' },
    { code: 'HT', name: 'Haiti' },
    { code: 'HM', name: 'Heard Island and Mcdonald Islands' },
    { code: 'VA', name: 'Holy See (Vatican City State)' },
    { code: 'HN', name: 'Honduras' },
    { code: 'HK', name: 'Hong Kong' },
    { code: 'HU', name: 'Hungary' },
    { code: 'IS', name: 'Iceland' },
    { code: 'IN', name: 'India' },
    { code: 'ID', name: 'Indonesia' },
    { code: 'IR', name: 'Iran, Islamic Republic Of' },
    { code: 'IQ', name: 'Iraq' },
    { code: 'IE', name: 'Ireland' },
    { code: 'IL', name: 'Israel' },
    { code: 'IT', name: 'Italy' },
    { code: 'JM', name: 'Jamaica' },
    { code: 'JP', name: 'Japan' },
    { code: 'JO', name: 'Jordan' },
    { code: 'KZ', name: 'Kazakhstan' },
    { code: 'KE', name: 'Kenya' },
    { code: 'KI', name: 'Kiribati' },
    { code: 'KP', name: "Korea, Democratic People's Republic of" },
    { code: 'KR', name: 'Korea, Republic of' },
    { code: 'KW', name: 'Kuwait' },
    { code: 'KG', name: 'Kyrgyzstan' },
    { code: 'LA', name: "Lao People's Democratic Republic" },
    { code: 'LV', name: 'Latvia' },
    { code: 'LB', name: 'Lebanon' },
    { code: 'LS', name: 'Lesotho' },
    { code: 'LR', name: 'Liberia' },
    { code: 'LY', name: 'Libyan Arab Jamahiriya' },
    { code: 'LI', name: 'Liechtenstein' },
    { code: 'LT', name: 'Lithuania' },
    { code: 'LU', name: 'Luxembourg' },
    { code: 'MO', name: 'Macao' },
    { code: 'MK', name: 'Macedonia, The Former Yugoslav Republic of' },
    { code: 'MG', name: 'Madagascar' },
    { code: 'MW', name: 'Malawi' },
    { code: 'MY', name: 'Malaysia' },
    { code: 'MV', name: 'Maldives' },
    { code: 'ML', name: 'Mali' },
    { code: 'MT', name: 'Malta' },
    { code: 'MH', name: 'Marshall Islands' },
    { code: 'MQ', name: 'Martinique' },
    { code: 'MR', name: 'Mauritania' },
    { code: 'MU', name: 'Mauritius' },
    { code: 'YT', name: 'Mayotte' },
    { code: 'MX', name: 'Mexico' },
    { code: 'FM', name: 'Micronesia, Federated States of' },
    { code: 'MD', name: 'Moldova, Republic of' },
    { code: 'MC', name: 'Monaco' },
    { code: 'MN', name: 'Mongolia' },
    { code: 'MS', name: 'Montserrat' },
    { code: 'MA', name: 'Morocco' },
    { code: 'MZ', name: 'Mozambique' },
    { code: 'MM', name: 'Myanmar' },
    { code: 'NA', name: 'Namibia' },
    { code: 'NR', name: 'Nauru' },
    { code: 'NP', name: 'Nepal' },
    { code: 'NL', name: 'Netherlands' },
    { code: 'AN', name: 'Netherlands Antilles' },
    { code: 'NC', name: 'New Caledonia' },
    { code: 'NZ', name: 'New Zealand' },
    { code: 'NI', name: 'Nicaragua' },
    { code: 'NE', name: 'Niger' },
    { code: 'NG', name: 'Nigeria' },
    { code: 'NU', name: 'Niue' },
    { code: 'NF', name: 'Norfolk Island' },
    { code: 'MP', name: 'Northern Mariana Islands' },
    { code: 'NO', name: 'Norway' },
    { code: 'OM', name: 'Oman' },
    { code: 'PK', name: 'Pakistan' },
    { code: 'PW', name: 'Palau' },
    { code: 'PS', name: 'Palestinian Territory, Occupied' },
    { code: 'PA', name: 'Panama' },
    { code: 'PG', name: 'Papua New Guinea' },
    { code: 'PY', name: 'Paraguay' },
    { code: 'PE', name: 'Peru' },
    { code: 'PH', name: 'Philippines' },
    { code: 'PN', name: 'Pitcairn' },
    { code: 'PL', name: 'Poland' },
    { code: 'PT', name: 'Portugal' },
    { code: 'PR', name: 'Puerto Rico' },
    { code: 'QA', name: 'Qatar' },
    { code: 'RE', name: 'Reunion' },
    { code: 'RO', name: 'Romania' },
    { code: 'RU', name: 'Russian Federation' },
    { code: 'RW', name: 'Rwanda' },
    { code: 'SH', name: 'Saint Helena' },
    { code: 'KN', name: 'Saint Kitts and Nevis' },
    { code: 'LC', name: 'Saint Lucia' },
    { code: 'PM', name: 'Saint Pierre and Miquelon' },
    { code: 'VC', name: 'Saint Vincent and the Grenadines' },
    { code: 'WS', name: 'Samoa' },
    { code: 'SM', name: 'San Marino' },
    { code: 'ST', name: 'Sao Tome and Principe' },
    { code: 'SA', name: 'Saudi Arabia' },
    { code: 'SN', name: 'Senegal' },
    { code: 'CS', name: 'Serbia and Montenegro' },
    { code: 'SC', name: 'Seychelles' },
    { code: 'SL', name: 'Sierra Leone' },
    { code: 'SG', name: 'Singapore' },
    { code: 'SK', name: 'Slovakia' },
    { code: 'SI', name: 'Slovenia' },
    { code: 'SB', name: 'Solomon Islands' },
    { code: 'SO', name: 'Somalia' },
    { code: 'ZA', name: 'South Africa' },
    { code: 'GS', name: 'South Georgia and the South Sandwich Islands' },
    { code: 'ES', name: 'Spain' },
    { code: 'LK', name: 'Sri Lanka' },
    { code: 'SD', name: 'Sudan' },
    { code: 'SR', name: 'Suriname' },
    { code: 'SJ', name: 'Svalbard and Jan Mayen' },
    { code: 'SZ', name: 'Swaziland' },
    { code: 'SE', name: 'Sweden' },
    { code: 'CH', name: 'Switzerland' },
    { code: 'SY', name: 'Syrian Arab Republic' },
    { code: 'TW', name: 'Taiwan, Province of China' },
    { code: 'TJ', name: 'Tajikistan' },
    { code: 'TZ', name: 'Tanzania, United Republic of' },
    { code: 'TH', name: 'Thailand' },
    { code: 'TL', name: 'Timor-Leste' },
    { code: 'TG', name: 'Togo' },
    { code: 'TK', name: 'Tokelau' },
    { code: 'TO', name: 'Tonga' },
    { code: 'TT', name: 'Trinidad and Tobago' },
    { code: 'TN', name: 'Tunisia' },
    { code: 'TR', name: 'Turkey' },
    { code: 'TM', name: 'Turkmenistan' },
    { code: 'TC', name: 'Turks and Caicos Islands' },
    { code: 'TV', name: 'Tuvalu' },
    { code: 'UG', name: 'Uganda' },
    { code: 'UA', name: 'Ukraine' },
    { code: 'AE', name: 'United Arab Emirates' },
    { code: 'GB', name: 'United Kingdom' },
    { code: 'US', name: 'United States' },
    { code: 'UM', name: 'United States Minor Outlying Islands' },
    { code: 'UY', name: 'Uruguay' },
    { code: 'UZ', name: 'Uzbekistan' },
    { code: 'VU', name: 'Vanuatu' },
    { code: 'VE', name: 'Venezuela' },
    { code: 'VN', name: 'Viet Nam' },
    { code: 'VG', name: 'Virgin Islands, British' },
    { code: 'VI', name: 'Virgin Islands, U.S.' },
    { code: 'WF', name: 'Wallis and Futuna' },
    { code: 'EH', name: 'Western Sahara' },
    { code: 'YE', name: 'Yemen' },
    { code: 'ZM', name: 'Zambia' },
    { code: 'ZW', name: 'Zimbabwe' }
];

function validateBackDatedVoucher(create_date, cut_off_date) {
    if (!create_date || !cut_off_date) return true;

    // Clean up cut_off_date string if it contains weekdays, e.g. "23-Dec-2025 (Tuesday)"
    const cleanCutOffDate = String(cut_off_date).replace(/\s*\(.*\)/, '').trim();
    
    const d1 = new Date(create_date);
    const d2 = new Date(cleanCutOffDate);
    
    if (isNaN(d1.getTime()) || isNaN(d2.getTime())) {
        return true;
    }
    
    d1.setHours(0, 0, 0, 0);
    d2.setHours(0, 0, 0, 0);

    return d1 >= d2;
}

const statesList = [
    { code: 'AN', name: 'Andaman and Nicobar Islands' },
    { code: 'AP', name: 'Andhra Pradesh' },
    { code: 'AR', name: 'Arunachal Pradesh' },
    { code: 'AS', name: 'Assam' },
    { code: 'BR', name: 'Bihar' },
    { code: 'CH', name: 'Chandigarh' },
    { code: 'CT', name: 'Chhattisgarh' },
    { code: 'DN', name: 'Dadra and Nagar Haveli and Daman and Diu' },
    { code: 'DL', name: 'Delhi' },
    { code: 'GA', name: 'Goa' },
    { code: 'GJ', name: 'Gujarat' },
    { code: 'HR', name: 'Haryana' },
    { code: 'HP', name: 'Himachal Pradesh' },
    { code: 'JK', name: 'Jammu and Kashmir' },
    { code: 'JH', name: 'Jharkhand' },
    { code: 'KA', name: 'Karnataka' },
    { code: 'KL', name: 'Kerala' },
    { code: 'LA', name: 'Ladakh' },
    { code: 'LD', name: 'Lakshadweep' },
    { code: 'MP', name: 'Madhya Pradesh' },
    { code: 'MH', name: 'Maharashtra' },
    { code: 'MN', name: 'Manipur' },
    { code: 'ML', name: 'Meghalaya' },
    { code: 'MZ', name: 'Mizoram' },
    { code: 'NL', name: 'Nagaland' },
    { code: 'OR', name: 'Odisha' },
    { code: 'PY', name: 'Puducherry' },
    { code: 'PB', name: 'Punjab' },
    { code: 'RJ', name: 'Rajasthan' },
    { code: 'SK', name: 'Sikkim' },
    { code: 'TN', name: 'Tamil Nadu' },
    { code: 'TS', name: 'Telangana' },
    { code: 'TR', name: 'Tripura' },
    { code: 'UP', name: 'Uttar Pradesh' },
    { code: 'UK', name: 'Uttarakhand' },
    { code: 'WB', name: 'West Bengal' }
];

export { dateFormateSend, dateFormateShow, dateDayShow, getVoucherDate, datePayment_func, addDecimalTwoPoint, countriesList, statesList, currencyFormate, currencyInputFormate, removeCurrencyComma, getDateInFormate, formatInputToCapitalization, getInvalidFromDate, getCurrentFinancialPeriod, getValidPeriodDate, parseNumeric, validateBackDatedVoucher }